import React from "react";
import { useTeamLocale } from "./TeamLocaleContext";

const ORT_OPTIONS = [
  { value: "all", labelKey: "ortFilter.all" },
  { value: "studio", labelKey: "ortFilter.studio" },
  { value: "edeka", labelKey: "ortFilter.edeka" },
  { value: "onsite", labelKey: "ortFilter.onsite" },
];

const TeamOrtFilter = ({ value, onChange }) => {
  const { t } = useTeamLocale();

  return (
    <label className="team-brand-filter">
      {t("ortFilter.label")}
      <select value={value} onChange={(e) => onChange(e.target.value)}>
        {ORT_OPTIONS.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {t(opt.labelKey)}
          </option>
        ))}
      </select>
    </label>
  );
};

export default TeamOrtFilter;
